<div class=" loading" *ngIf="loader">Loading&#8230;</div>
<div class="row no-gutters bot_spa_aft_sect_heading content_top_margin">
    <div class="col-12">
        <span class="sectionHeading_one" role="heading" aria-level="2">{{ 'information.titleTextBox' | translate }}</span>
    </div>
</div>
<ng-container *ngIf="(!isCoapplicantApplied && !isExistingCustomer) || (isCoapplicantApplied && !isExistingCustomer)">
    <div class="row no-gutters bot_spa_aft_sect_heading" *ngIf="isCoapplicantApplied&&!isExistingCustomer">
        <div class="col-12">
            <span id="applicant" class="sectionHeading_two" role="heading" aria-level="3">
                {{'information.applicant' |
                translate }}
            </span>
        </div>
    </div>
    <form [formGroup]="infoForm">
        <div class="row no-gutters space_between_section">
            <div class="col-xs-12 col-sm-12 col-lg-5">
                <small
                    class="form-text col-xs-12 col-sm-12 d-flex field_heading_minHeight_label align-items-center p-0 m-0">
                    <label for="mobileNumber" id="appmob" class="field_lable_bot_margin_unset">{{
                        'information.phone' | translate }}
                    </label>
                </small>
                <input type="text" class="wdd-fl phoneAllign border-cls" id="mobileNumber" [readonly]="loader"
                    tabindex="0" autocomplete="tel-local" spellcheck="false" (keyup)="persTempContact()"
                    formControlName="mobileNumber" mask="000-000-0000" aria-required="true" aria-describedby="appPhnNoErrMsg"
                    aria-labelledby="applicant appmob"
                    [ngClass]="(f.mobileNumber.touched || submitted) && (f.mobileNumber.errors?.invalidNumber || f.mobileNumber.errors?.required) ? 'invalidBorder' : 'nonSelectBorder'">

                <div class="row no-gutters"
                    *ngIf="f.mobileNumber.invalid && (f.mobileNumber.dirty || f.mobileNumber.touched || submitted)">
                    <div class="col-12">
                        <small class="d-flex align-items-start mt-1 errorMsg">
                            <ng-container *ngIf="f.mobileNumber.errors?.required ">
                                <img src="./assets/images/menu_icons/Alert.svg" alt=""> <span class="ml-2" id="appPhnNoErrMsg">
                                    {{ 'information.pnerrormsg' | translate
                                    }}
                                </span>
                            </ng-container>
                            <ng-container
                                *ngIf="f.mobileNumber.errors?.invalidNumber && !f.mobileNumber.errors?.required">
                                <img src="./assets/images/menu_icons/Alert.svg" alt=""> <span class="ml-2" id="appPhnNoErrMsg">
                                    {{ 'information.pnerrormsg' |
                                    translate }}
                                </span>
                            </ng-container>
                        </small>
                    </div>
                </div>

            </div>
            <div class="col-xs-12 col-sm-12 col-lg-5   space_between_field">
                <small
                    class="form-text col-xs-12 col-sm-12 d-flex field_heading_minHeight_label align-items-center p-0 m-0">
                    <label for="eMail" id="appemail" class="field_lable_bot_margin_unset">{{ 'information.email' |
                        translate }}
                    </label>
                </small>

                <input type="text" class="wdd-fl  emailAllign  border-cls" [readonly]="loader" tabindex="0"
                    spellcheck="false" (keyup)="persTempContact()" formControlName="eMail" aria-describedby="appEmailErrMsg"
                    aria-labelledby="applicant appemail"
                    [ngClass]="(f.eMail.touched || submitted) && ((f.eMail.errors?.pattern && !f.eMail.errors?.validEmail) || f.eMail.errors?.required || f.eMail.errors?.invalidEmail) ? 'invalidBorder' :'nonSelectBorder'"
                    id="eMail" aria-required="true" autocomplete="email" maxlength="50">
                <div class="row no-gutters">
                    <div class="col-12">
                        <small 
                            *ngIf="f.eMail.errors?.pattern && !f.eMail.errors?.validEmail && !f.eMail.errors?.required"
                            class="d-flex align-items-start mt-1 errorMsg"> <img src="./assets/images/menu_icons/Alert.svg"
                                alt=""> <span class="ml-2" id="appEmailErrMsg">
                                {{ 'information.emailerrormsg' | translate }}
                            </span>
                        </small>
                    </div>
                </div>

                <div class="row no-gutters" *ngIf=" f.eMail.invalid && (f.eMail.dirty || f.eMail.touched || submitted)">
                    <div class="col-12">
                        <small  *ngIf="f.eMail.errors?.required " class="d-flex align-items-start mt-1 errorMsg">
                            <img src="./assets/images/menu_icons/Alert.svg" alt=""> <span class="ml-2" id="appEmailErrMsg">
                                {{ 'information.emailerrormsg' |
                                translate
                                }}
                            </span>
                        </small>
                        <small 
                            *ngIf="f.eMail.errors?.invalidEmail && !f.eMail.errors?.pattern && !f.eMail.errors?.required"
                            class="d-flex align-items-start mt-1 errorMsg"><img src="./assets/images/menu_icons/Alert.svg"
                                alt=""> <span class="ml-2" id="appEmailErrMsg">
                                {{ 'information.emailerrormsg' | translate }}
                            </span>
                        </small>
                    </div>
                </div>
            </div>
        </div>
    </form>
</ng-container>
<ng-container *ngIf="(isCoapplicantApplied && isExistingCustomer) || (isCoapplicantApplied && !isExistingCustomer)">
    <div class="row no-gutters bot_spa_aft_sect_heading" *ngIf="isCoapplicantApplied && !isExistingCustomer">
        <div class="col-12">
            <span id="coapplicant" class="sectionHeading_two"  role="heading" aria-level="3">{{
                'information.coApplicant' | translate }}</span>
        </div>
    </div>
    <form [formGroup]="coapplicantInfoForm">
        <div class="row no-gutters space_between_section">
            <div class="col-xs-12 col-sm-12 col-lg-5">
                <small
                    class="form-text col-xs-12 col-sm-12 d-flex field_heading_minHeight_label align-items-center p-0 m-0">
                    <label for="mobileNumber" id="comob" class="field_lable_bot_margin_unset">{{ 'information.phone'
                        | translate }}
                    </label>
                </small>
                <input type="text" class="wdd-fl phoneAllign border-cls" id="mobileNumber" [readonly]="loader"
                    tabindex="0" autocomplete="tel-local" spellcheck="false" (keyup)="coapplicantPersTempContact()"
                    formControlName="mobileNumber" mask="000-000-0000" aria-required="true"
                    aria-describedby="coappPhnNoErrMsg" aria-labelledby="coapplicant comob"
                    [ngClass]="(cf.mobileNumber.touched || coSubmitted) && (cf.mobileNumber.errors?.invalidNumber || cf.mobileNumber.errors?.required) ? 'invalidBorder' : 'nonSelectBorder'">
                <div class="row no-gutters"
                    *ngIf="cf.mobileNumber.invalid && (cf.mobileNumber.dirty || cf.mobileNumber.touched || coSubmitted)">
                    <div class="col-12">
                        <small  *ngIf="cf.mobileNumber.errors?.required"
                            class="d-flex align-items-start mt-1 errorMsg"> <img src="./assets/images/menu_icons/Alert.svg"
                                alt=""> <span class="ml-2" id="coappPhnNoErrMsg">
                                {{ 'information.pnerrormsg' | translate
                                }}
                            </span>
                        </small>
                        <small 
                            *ngIf="cf.mobileNumber.errors?.invalidNumber && !cf.mobileNumber.errors?.required"
                            class="d-flex align-items-start mt-1 errorMsg"> <img src="./assets/images/menu_icons/Alert.svg"
                                alt=""> <span class="ml-2" coappPhnNoErrMsg>
                                {{ 'information.pnerrormsg' |
                                translate }}
                            </span>
                        </small>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-lg-5 space_between_field">
                <small
                    class="form-text col-xs-12 col-sm-12 d-flex field_heading_minHeight_label align-items-center p-0 m-0">
                    <label for="eMail" id="coemail" class="field_lable_bot_margin_unset">{{ 'information.email' |
                        translate }}
                    </label>
                </small>
                <input type="text" class="wdd-fl  emailAllign border-cls" [readonly]="loader" tabindex="0"
                    spellcheck="false" (keyup)="coapplicantPersTempContact()" formControlName="eMail"
                    aria-describedby="coappmailErrMsg"
                    [ngClass]="(cf.eMail.touched || coSubmitted) && ((cf.eMail.errors?.pattern && !cf.eMail.errors?.validEmail) || cf.eMail.errors?.required || cf.eMail.errors?.invalidEmail) ? 'invalidBorder' :'nonSelectBorder'"
                    id="eMail" aria-required="true" autocomplete="email" maxlength="50"
                    aria-labelledby="coapplicant coemail">
                <div class="row no-gutters">
                    <div class="col-12">
                        <small 
                            *ngIf="cf.eMail.errors?.pattern && !cf.eMail.errors?.validEmail && !cf.eMail.errors?.required"
                            class="d-flex align-items-start mt-1 errorMsg">
                            <img src="./assets/images/menu_icons/Alert.svg" alt="">
                            <span class="ml-2" id="coappmailErrMsg">
                                {{ 'information.emailerrormsg' | translate }}
                            </span>
                        </small>
                    </div>
                </div>

                <div class="row no-gutters"
                    *ngIf="cf.eMail.invalid && (cf.eMail.dirty || cf.eMail.touched || coSubmitted)">
                    <div class="col-12">
                        <small  *ngIf="cf.eMail.errors?.required "
                            class="d-flex align-items-start mt-1 errorMsg"> <img
                                src="./assets/images/menu_icons/Alert.svg" alt=""> <span class="ml-2" id="coappmailErrMsg">
                                {{ 'information.emailerrormsg' |
                                translate
                                }}
                            </span>
                        </small>
                        <small 
                            *ngIf="cf.eMail.errors?.invalidEmail && !cf.eMail.errors?.pattern && !cf.eMail.errors?.required"
                            class="d-flex align-items-start mt-1 errorMsg"><img
                                src="./assets/images/menu_icons/Alert.svg" alt=""> <span class="ml-2" id="coappmailErrMsg">
                                {{ 'information.emailerrormsg' | translate }}
                            </span>
                        </small>
                    </div>
                </div>
            </div>
        </div>
    </form>
</ng-container>
<div class="row no-gutters">
    <div class="col-12 noteContainer d-flex align-items-start">
        <img src="./assets/icons/info-square-filled.svg" alt="" class="pr-2">
        <div>
            <span *ngIf="preQualObj.flow_type==prequalType" id="personalInformationContactContent">{{
                'about.contactRemarkPrequal' | translate }} </span>
            <span *ngIf="preQualObj.flow_type==switchType" id="personalInformationContactContent">{{
                'about.contactRemarkSwitch' | translate }} </span>
            <a [href]="privacyandsecurityLink" class=" pr-0" target="_blank" data-toggle="tooltip" data-placement="top">
                <span class="note_link"><u>{{'information.privacyPolicy' | translate}}</u></span>
                <span class="show-for-sr">{{'Notyetaclient.privacyPolicy' | translate}}</span>
            </a>
            <span>{{'Notyetaclient.dot'|translate}}</span>
            <span>{{'about.contactRemarkPrequalNext'|translate}}</span>
        </div>
    </div>
</div>
<div class="row no-gutters top_height_actionButton content_top_mobile_margin">
    <div class="col-12 d-flex d-md-block flex-column-reverse">
        <cancel-button></cancel-button>
        <button type="button" class="common_btn saveNextBtn_features space_between_button"
            (click)="onContinue()">{{'buttonallpages.continuelable' | translate }}</button>
    </div>
</div>